import {Component} from '@angular/core';

@Component({
  selector: 'app-payment-icons',
  templateUrl: './payment-icons.component.html',
  styleUrl: './payment-icons.component.scss'
})
export class PaymentIconsComponent {

}
